import { FadeIn } from './FadeIn';
export const Animate = {
    FadeIn,
};
//# sourceMappingURL=index.js.map